import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Team } from '../../services/cebl.api.types';
import { WordpressServiceExtended } from '../../services/wordpress.api.service';
import { WpCommonData, WpCommonDataTeam } from '../../types/wordpress/common-data.type';
import { loadTeams, loadTeamsFailure, loadTeamsSuccess } from './teams.actions';
import { WordpressService } from '@streamamg/wordpress-lib';

@Injectable()
export class TeamsEffects {

  loadTeams$ = createEffect(() => this.actions$.pipe(
    ofType(loadTeams),
    switchMap((params) => combineLatest([
      this.wordpressService.getCommonData<WpCommonData>(),
      this.wordpressServiceExtended.getTeams(),
    ])),
    map(([wpCommonData, wpTeams]) => {

      const teams: Team[] = [];
      const teamsMap: Map<string, Team> = new Map();
      wpTeams.forEach((t) => {
        const team: Team = {
          teamId: parseInt(t.team_id, 10),
          teamName: t.post_title,
          slug: t.post_slug,
          wpTeam: t,
        };

        teams.push(team);
        teamsMap.set(team.slug, team);
        teamsMap.set(team.teamId.toString(), team);
        teamsMap.set(team.teamName, team);
      });

      const teamsMatchesMap: Map<string, Team> = new Map();
      if (wpCommonData.teams?.length > 0) {
        wpCommonData.teams
          .forEach((i: WpCommonDataTeam) => {
            const slugList = i.team.split('/');
            let slug = '';
            while (slug === '') {
              slug = slugList.pop();
            }

            const team = teamsMap.get(slug);
            if (team) {
              teamsMatchesMap.set(team.slug, team);
              teamsMatchesMap.set(team.teamId.toString(), team);
              teamsMatchesMap.set(team.teamName, team);
            }
          });
      }

      return loadTeamsSuccess({
        data: {
          teams,
          teamsMap: teamsMap || null,
          teamsMatchesMap: teamsMatchesMap || null,
        },
      });
    }),
    catchError(error => of(loadTeamsFailure(error))),
  ), {dispatch: true});

  constructor(
    private actions$: Actions,
    private wordpressService: WordpressService,
    private wordpressServiceExtended: WordpressServiceExtended,
  ) {
  }
}
